import "./YesterdayNotificationComponent.css";
import React from "react";
import { Fragment } from "react";
import UpdateNotificationStatus from "../../../controllers/users/UpdateNotificationStatus";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
const YesterdayNotificationComponent = ({
  notification,
  YesterdayNotifications,
  setYesterdayNotifications,
}) => {
  const onClickHandler = async () => {
    const notificationId = notification?.id;
    await UpdateNotificationStatus(notificationId);
    const newState = YesterdayNotifications.map((obj) => {
      if (obj.id === notificationId) {
        return { ...obj, is_seen: true };
      }
      return obj;
    });

    setYesterdayNotifications(newState);
  };
  return (
    <Fragment>
      {notification && (
        <li
          onClick={notification?.is_seen === false ? onClickHandler : undefined}
          className={`ul-list-element ${
            notification?.is_seen === false ? "not-read-notifications" : ""
          }`}
        >
          <div className="timeline-panel all-notifications-list-element">
            <div className="media mr-2">
              <div className="notification-drop-down-image" width="50" />
              {notification?.notification_type === "Deal is Won" ? (
                <AssuredWorkloadIcon />
              ) : notification?.notification_type === "Shared" ? (
                <AddBusinessIcon />
              ) : (
                <DensitySmallIcon />
              )}
            </div>
            <div className="media-body" style={{ margin: "0px 0px 0px 10px" }}>
              {notification?.is_seen === true ? (
                <h4
                  className="mb-1 notification-bell-text"
                  style={{
                    color: "lightgrey",
                  }}
                >
                  {notification?.title}
                </h4>
              ) : (
                <h4 className="mb-1 notification-bell-text">
                  {notification?.title}
                </h4>
              )}
              <small className="d-block" style={{ color: "#A5ACB8" }}>
                {notification?.createdAt?.toDate()?.toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                })}
              </small>
            </div>
          </div>
        </li>
      )}
    </Fragment>
  );
};

export default YesterdayNotificationComponent;
